import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as speaker from "./style.module.scss";

export const Speaker = () => {
  return (
    <section className={`${speaker.speaker} ${main.sec}`}>
      <div className="container">
        <div className={main.blockTitle}>
          Преподаватель
        </div>

        <div className={`row ${speaker.speaker_row}`}>
          <div className={`col col-7 ${speaker.speaker_col} ${speaker.speaker_colLeft}`}>
            <ul className={speaker.speaker_colList}>
              <li>Обучил более <span>1000&nbsp;школьников.</span></li>
              <li>Посетил <span> 25&nbsp;стран, </span>знает более <span>1000&nbsp;фактов по&nbsp;географии.</span>
              </li>
              <li>Разработчик тренингов по&nbsp;технологиям эффективного обучения.</li>
              <li>Проводил курсы <span> в&nbsp;3&nbsp;странах: </span> на&nbsp;Кипре, в&nbsp;Казахстане, в&nbsp;России.
              </li>
              <li>Владеет алфавитом Брайля и&nbsp;азбукой Морзе.</li>
              <li>Преподаватель технологий обучения и&nbsp;английского языка
                в&nbsp;Advance c&nbsp;2015&nbsp;года.
              </li>
            </ul>
          </div>
          <div className={`col col-5 ${speaker.speaker_col} ${speaker.speaker_colRight}`}>
            <div className={speaker.speaker_colIcon}>
              <img src="https://fs.advance.ru/landing-pages/online/globus/shek.jpg" alt="Артур Шек"/>
            </div>
            <div className={speaker.speaker_colName}>Артур Шек</div>
            <div className={speaker.speaker_colDesc}>Преподаватель курсов <br/>
              технологий и&nbsp;языков
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
